import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from '../../../../styles/icons/default.scss';

const propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    color: 'currentColor',
    className: null,
};

const LineSmaller = ({ color, className }) => (
    <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        width="80px"
        height="2px"
        viewBox="0 0 80 2"
        className={classNames([styles.container, { [className]: className !== null }])}
        xmlSpace="preserve"
    >
        <g>
            <path
                fill={color}
                d="M79.1,0.4c-0.1,0-0.2-0.1-0.2-0.1c-0.2,0.1-0.2,0-0.2-0.1c-0.1-0.2-0.4-0.1-0.6-0.1c-0.2,0.3-0.5,0-0.7,0
        		c-0.2,0-0.4,0.1-0.5,0.1c-0.4-0.1-0.8-0.1-1.1-0.1c-0.2,0-0.4,0-0.5-0.2c-0.1,0.1-0.1,0.2-0.2,0.4c-0.4-0.3-0.9-0.3-1.4-0.2
        		c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0-0.2,0.1-0.3,0.1c-0.1-0.1-0.1-0.1-0.1-0.1c-0.3,0-0.6,0.1-0.8,0.1
        		c-0.4-0.1-0.8,0-1.2,0c-0.4,0-0.9,0.1-1.1-0.1c-0.2,0-0.3,0.1-0.5,0.1c-0.2,0-0.3-0.1-0.5-0.1c-0.1,0.1-0.3,0.2-0.5,0.1
        		c-0.2,0-0.3-0.1-0.5-0.1c-0.2,0-0.5,0-0.6,0.1c-0.2-0.1-0.4-0.1-0.6-0.2c-0.1,0.1-0.2,0.1-0.4,0.2C66,0.2,66,0.1,66,0.1
        		c-0.2,0-0.5,0-0.4,0.2c-0.2,0-0.3,0-0.5,0c-0.1,0-0.2,0-0.3,0c-0.3-0.1-0.6-0.2-0.8,0c0,0-0.1,0-0.1,0c-0.2-0.1-0.4,0-0.7,0
        		c-0.1,0-0.2-0.1-0.3-0.1c-0.4,0.1-0.4,0.1-1.1,0c0,0.1,0,0.1,0,0.2c-0.6-0.1-1.1-0.2-1.6,0c-0.4-0.1-0.9,0.1-1.2-0.1
        		c-0.2,0-0.4,0.1-0.5,0.1c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1,0.1-0.1,0.1-0.2,0.2c-0.3,0-0.6-0.1-0.8,0c-0.3,0-0.5,0-0.7-0.1
        		c-0.1,0-0.2,0-0.3-0.1c0,0.1,0,0.1-0.1,0.2c-0.3-0.1-0.5-0.1-0.8-0.2c0,0-0.1,0-0.1,0c-0.1,0.1-0.3,0.1-0.4,0.2
        		c0,0-0.1-0.1-0.1-0.2c-0.2,0-0.3,0.1-0.5,0.1c-0.1,0-0.2-0.1-0.3-0.1c-0.2,0-0.4,0.1-0.5,0.1c-0.7-0.1-1.4,0-2.1-0.1
        		c-0.1,0-0.2,0-0.3,0c-0.4,0.2-0.9,0-1.4,0c-0.3-0.2-0.5,0-0.7,0.1c-0.3-0.2-0.5-0.3-0.9-0.1c-0.1,0-0.2,0-0.2,0
        		c-0.4-0.1-0.6,0-0.9,0.2c-0.1-0.1-0.1-0.2-0.2-0.2c-0.4,0.1-0.8,0-1.2,0c-0.5,0-1,0.1-1.5,0c-0.3,0.1-0.6,0-0.9-0.1
        		c-0.1,0-0.3,0-0.3,0c-0.3,0.3-0.5,0.1-0.7,0c-0.5,0.1-0.5,0.1-0.6-0.2c-0.1,0.1-0.2,0.2-0.4,0.3c-0.3-0.2-0.8,0.1-1.1-0.2
        		c-0.1,0.1-0.1,0.2-0.2,0.3c-0.2-0.1-0.5-0.2-0.7-0.3c-0.4,0.2-0.8,0-1.2,0.1c0,0,0,0.1,0,0.1c-0.4,0-0.7,0-0.9-0.2
        		c-0.2,0-0.4,0.3-0.7,0.2c-0.4-0.2-0.4,0.1-0.6,0.2c-0.2-0.1-0.3-0.4-0.7-0.1c-0.1-0.1-0.2-0.2-0.3-0.2c-0.2,0.1-0.4,0.1-0.5,0.1
        		c-0.1-0.1-0.1-0.1-0.1-0.1c-0.2,0.1-0.4,0.1-0.6,0.2c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1,0.1-0.2,0.1-0.4,0.2c-0.1-0.1-0.1-0.2-0.2-0.2
        		c-0.4,0.2-0.7,0.2-1.1,0.1c-0.5-0.1-0.9-0.1-1.3,0c-0.2,0-0.4,0-0.6-0.1c-0.3-0.1-0.3,0.2-0.5,0.1c-0.1-0.1-0.2-0.1-0.3-0.2
        		c-0.2,0.1-0.4,0.2-0.5,0.2c-0.2-0.1-0.5-0.1-0.7-0.2c-0.1,0.1-0.2,0.1-0.2,0.2c-0.1,0-0.2,0-0.3,0c-0.1,0-0.3,0-0.4,0
        		c-0.3,0-0.6-0.2-0.8,0.1c-0.3-0.1-0.7,0-1-0.1c-0.1-0.1-0.3-0.1-0.3,0c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0-0.2,0.1-0.2,0.1
        		c-0.1,0-0.1-0.1-0.2-0.1c-0.1,0-0.1-0.1-0.1-0.1c-0.1,0-0.2,0.1-0.3,0.1c-0.2,0-0.4-0.1-0.6-0.1c-0.4,0-0.5,0-0.6,0.3
        		c0,0-0.1,0-0.2,0c0-0.1,0-0.2,0-0.3c-0.2,0-0.3,0-0.4,0.1c-0.1,0-0.2,0.1-0.3,0c-0.1,0-0.1-0.1-0.2-0.2c-0.2,0.1-0.4,0.2-0.5,0.3
        		c-0.2,0-0.4,0-0.6-0.1c-0.5-0.1-0.5-0.1-0.7,0.1c-0.2-0.2-0.5-0.2-0.7-0.1c-0.2,0.1-0.4,0-0.6,0c-0.3,0-0.5-0.1-0.8,0
        		c-0.2,0.1-0.3,0-0.5,0c-0.3-0.1-0.4,0-0.4,0.1c-0.5,0.1-0.9-0.2-1.5-0.2c0.1,0.1,0.1,0.1,0.1,0.2c-0.4,0.1-0.6,0-0.7-0.2
        		c-0.2,0.1-0.3,0.1-0.7,0.1c0,0-0.1,0-0.1,0c-0.2,0.2-0.4,0.1-0.6,0c-0.1,0-0.4,0-0.4,0c-0.1,0.2-0.3,0.1-0.4,0.1
        		c-0.2,0.2-0.4-0.1-0.6,0c-0.2,0-0.4,0.1-0.7,0c-0.1-0.1-0.5,0-0.7,0c-0.3,0-0.5-0.1-0.8-0.1C9.2,0.2,9.2,0.2,9.1,0.3
        		C8.9,0.2,8.8,0.2,8.6,0.1C8.4,0.3,8.1,0.3,7.8,0.2c-0.1,0-0.3-0.1-0.5-0.1c0.1,0.1,0.1,0.1,0.1,0.2c-0.3,0-0.5,0-0.6-0.1
        		c-0.3-0.2-0.4-0.1-0.7,0c-0.3,0.1-0.6,0.1-1,0.1C5,0.4,4.8,0.2,4.6,0.2C4.4,0.3,4.1,0.4,3.9,0.3c-0.3-0.1-1-0.1-1.3,0
        		c-0.2,0-0.4,0-0.5-0.1c0,0-0.1,0-0.1-0.1c0,0.1,0,0.1,0,0.2c-0.4,0-0.8-0.1-1.1-0.1C0.6,0.3,0.5,0.3,0.4,0.4C0.2,0.5,0,0.6,0,0.7
        		l0.5,0.2c0.3,0,0.7,0.1,1.2,0.1c0-0.1,0-0.1,0-0.2c0.1,0,0.1,0,0.2,0.1C1.9,1,2,1,2.3,1c0.1,0,0.3,0,0.6,0c0,0,0.1,0,0.1,0
        		c0,0,0,0,0,0C3.2,1,3.5,1,3.7,1c0.2,0,0.5,0,0.7-0.2C4.6,0.9,4.7,1,4.9,1c0.3,0,0.7,0,1-0.1c0.3-0.1,0.5-0.2,0.8,0C6.7,1,7,1,7.3,1
        		C7.2,0.9,7.2,0.9,7.1,0.8c0.2,0,0.4,0.1,0.5,0.1C8,1,8.3,1,8.5,0.7c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0.1,0,0.1-0.1
        		c0,0.1,0,0.1,0,0.1c0,0,0,0,0,0C8.8,0.9,8.9,0.9,9,1c0.1-0.1,0.1-0.1,0.2-0.2C9.5,0.9,9.7,1,10,0.9c0.2,0,0.6-0.1,0.7,0
        		c0.3,0.1,0.5,0.1,0.7,0c0.2,0,0.3,0.2,0.6,0c0,0,0.3,0.1,0.4-0.1c0,0,0.1,0,0.1,0c0,0-0.1-0.1-0.1-0.1c0,0,0.1,0,0.1-0.1
        		c0,0,0.1,0,0.1,0.1c0,0,0,0-0.1,0.1c0.1,0,0.2,0,0.2,0c0.2,0.1,0.4,0.2,0.6,0c0,0,0.1,0,0.1,0c0.4,0,0.5,0,0.7-0.1
        		C14.5,1,14.7,1.1,15.1,1c0-0.1-0.1-0.1-0.1-0.2c0.5,0,1,0.3,1.5,0.2c0.1-0.2,0.2-0.2,0.5-0.1c0.2,0,0.3,0.1,0.5,0
        		c0.3-0.1,0.5,0,0.8,0c0.2,0,0.4,0,0.6,0c0.2-0.1,0.6,0,0.7,0.1c0.3-0.2,0.3-0.2,0.8-0.1C20.6,0.9,20.8,1,21,1
        		c0.2-0.1,0.4-0.2,0.6-0.3c0.1,0.1,0.1,0.2,0.2,0.2c0.1,0,0.2,0,0.3,0c0.1,0,0.3,0,0.5-0.1c0,0.1,0,0.2,0,0.4c0.1,0,0.2,0,0.2,0
        		c0.1-0.2,0.3-0.3,0.7-0.3C23.6,0.9,23.8,1,24,1c0.1,0,0.2,0,0.3-0.1c0,0,0.1,0.1,0.1,0.1c0.1,0,0.1,0.1,0.2,0.1
        		c0.1,0,0.2-0.1,0.3-0.1c0.1,0,0.3,0,0.3-0.1c0.1-0.1,0.2-0.1,0.3,0c0.3,0.2,0.7,0,1,0.1c0.2-0.2,0.5-0.1,0.8-0.1c0.1,0,0.3,0,0.4,0
        		c0.1,0,0.2,0,0.4,0c0.1-0.1,0.1-0.1,0.2-0.2C28.6,0.9,28.8,0.9,29,1c0.2-0.1,0.3-0.2,0.5-0.2c0.1,0.1,0.2,0.1,0.3,0.2
        		c0.2,0.1,0.3-0.2,0.6-0.1c0.2,0,0.4,0,0.6,0.1c0.4-0.1,0.9-0.1,1.4,0c0.3,0.1,0.7,0,1.1-0.1c0.1,0.1,0.1,0.2,0.2,0.3
        		c0.2-0.1,0.3-0.2,0.4-0.3c0.1,0.1,0.2,0.1,0.2,0.2c0.2-0.1,0.4-0.1,0.6-0.2c0,0,0.1,0.1,0.2,0.1c0.1,0,0.3-0.1,0.5-0.1
        		c0.1,0.1,0.2,0.1,0.3,0.2c0,0,0,0,0,0c-0.1-0.1,0-0.2,0-0.3c0,0.1,0.1,0.1,0.1,0.2c0.2-0.1,0.4,0.1,0.5,0.2
        		c0.2-0.1,0.2-0.3,0.6-0.2c0.3,0.1,0.4-0.1,0.7-0.2C38.1,0.9,38.4,1,38.8,1c0-0.1,0-0.1,0-0.1C39.2,0.8,39.6,1,40,0.8
        		c0.2,0.1,0.5,0.2,0.7,0.3C40.8,1,40.9,0.9,41,0.8c0.3,0.2,0.8,0,1.1,0.2c0.1-0.1,0.2-0.2,0.4-0.3c0,0.3,0.1,0.3,0.6,0.2
        		c0.2,0.1,0.5,0.3,0.8,0c0,0,0.2,0,0.3,0c0.2,0,0.5,0.1,0.7,0.1c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0.1,0c0.5,0.1,1.1,0,1.6,0
        		c0.4,0,0.8,0.1,1.3,0c0,0,0.1,0.1,0.2,0.2c0.2-0.1,0.5-0.3,0.9-0.2c0.1,0,0.2,0,0.2,0c0.4-0.2,0.6-0.1,0.9,0.1
        		c0.2-0.1,0.4-0.4,0.8-0.1c0.5-0.1,1,0.2,1.4-0.1c0.1,0,0.2,0,0.3,0c0.7,0.1,1.4,0,2.1,0.1c0.2,0,0.4-0.1,0.6-0.1
        		c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.3,0,0.5-0.1C56.1,0.9,56.2,1,56.2,1c0.1-0.1,0.3-0.1,0.4-0.2c0,0,0.1,0,0.1,0
        		C57,0.8,57.3,0.9,57.5,1c0-0.1,0.1-0.2,0.1-0.3c0.1,0,0.2,0,0.3,0.1c0.2,0.1,0.5,0.1,0.8,0.1c0.2,0,0.5,0,0.8,0.1
        		c0,0,0.1-0.1,0.2-0.2c0.1,0.1,0.2,0.1,0.3,0.2c0.1,0,0.1,0,0.2-0.1c0,0-0.1,0-0.1-0.1c0.1,0,0.2,0,0.3,0c0,0,0.1,0,0.1,0
        		c0,0,0,0,0.1,0c-0.1-0.1,0-0.2,0.2-0.2c0,0.1,0,0.2,0.1,0.3c-0.1,0-0.2,0-0.3,0c0.3,0.2,0.8,0,1.2,0.1c0.6-0.2,1.1-0.1,1.7,0
        		c0-0.1,0-0.1,0-0.2c0.8,0.1,0.8,0.1,1.2,0c0.1,0,0.2,0.1,0.3,0.1c0.2,0,0.5-0.1,0.7,0c0,0,0.1,0,0.1,0c0.3-0.2,0.6-0.1,0.9,0
        		c0.1,0,0.2,0,0.3,0c0.2,0,0.3,0,0.5,0c0-0.2,0.2-0.2,0.4-0.2C67.9,0.8,68,0.9,68,1c0.1-0.1,0.2-0.2,0.4-0.2
        		c0.2,0.1,0.4,0.1,0.6,0.2c0.1-0.2,0.4-0.2,0.6-0.1c0.2,0,0.3,0.1,0.5,0.1c0.3,0.1,0.4,0,0.5-0.1c0.2,0,0.3,0.1,0.5,0.1
        		c0.1,0,0.3,0,0.5-0.1c0.3,0.2,0.7,0.1,1.2,0.1c0.4,0,0.8-0.1,1.2,0c0.2,0,0.5,0,0.8-0.1c0,0,0.1,0.1,0.1,0.1
        		c0.2-0.1,0.3-0.1,0.3-0.1c0.1,0,0.2-0.1,0.3-0.1c0.1,0.1,0.2,0.1,0.3,0.2c0.5-0.1,1-0.1,1.5,0.2c0.1-0.1,0.1-0.2,0.2-0.4
        		c0.2,0.1,0.3,0.2,0.5,0.2c0.4,0,0.8-0.1,1.2,0.1c0.1,0,0.3,0,0.5-0.1c0.1,0,0.2,0,0.3,0.1c0,0,0-0.1,0-0.1c0-0.2-0.1-0.3-0.4-0.3
        		c-0.1,0-0.2-0.1-0.3-0.1C79.3,0.3,79.2,0.4,79.1,0.4z M3.2,0.8c-0.3,0-0.4,0-0.3-0.2C3,0.7,3.1,0.7,3.2,0.8z M4.6,0.5
        		c0,0-0.1,0-0.1,0c0,0,0.1,0,0.1-0.1c0.1,0,0.1,0,0.1,0.1C4.7,0.4,4.7,0.5,4.6,0.5z M6.6,0.7C6.6,0.7,6.5,0.7,6.6,0.7
        		c-0.1,0-0.1-0.1-0.1-0.1c0,0,0.1,0,0.1,0C6.6,0.7,6.6,0.7,6.6,0.7z M8,0.7C7.9,0.5,7.9,0.5,8.2,0.5C8.1,0.6,8,0.6,8,0.7z M13.4,0.9
        		c0,0-0.1,0-0.1,0.1c0,0-0.1-0.1-0.1-0.1c0,0,0.1,0,0.1-0.1C13.4,0.8,13.4,0.9,13.4,0.9z M14.1,0.5c-0.1,0-0.1,0-0.1-0.1
        		c0,0,0.1,0,0.1-0.1c0,0,0.1,0.1,0.1,0.1C14.2,0.4,14.1,0.5,14.1,0.5z M16.6,0.8c0,0-0.1,0.1-0.1,0.1c0,0-0.1,0-0.1-0.1
        		c0,0,0,0,0.1-0.1C16.5,0.7,16.6,0.7,16.6,0.8z M35.9,0.7c-0.2,0.1-0.3,0-0.2-0.2C35.8,0.6,35.9,0.6,35.9,0.7z M45.9,0.6
        		c0.1-0.1,0.2-0.2,0.4-0.1C46.2,0.5,46.2,0.7,45.9,0.6z"
            />
            <path fill={color} d="M36.8,1.4c-0.1,0-0.1-0.1-0.2-0.2C36.5,1.4,36.6,1.4,36.8,1.4z" />
            <path fill={color} d="M47.1,1.3c0.3,0.1,0.4,0,0.5-0.1C47.3,1.1,47.2,1.2,47.1,1.3z" />
            <path
                fill={color}
                d="M8.5,1.6c0,0,0.1,0,0.1,0c0,0,0-0.1,0-0.1C8.5,1.4,8.5,1.4,8.5,1.6C8.5,1.5,8.5,1.5,8.5,1.6z"
            />
            <path fill={color} d="M7.8,1.4C7.9,1.3,8,1.3,8.1,1.2C7.7,1.2,7.7,1.2,7.8,1.4z" />
            <path
                fill={color}
                d="M6.3,1.4C6.3,1.4,6.4,1.4,6.3,1.4c0.1-0.1,0.1-0.1,0.1-0.1c0,0-0.1,0-0.1,0C6.3,1.3,6.3,1.4,6.3,1.4z"
            />
            <path
                fill={color}
                d="M4.3,1.1c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1-0.1c0,0-0.1,0-0.1-0.1C4.3,1.1,4.3,1.1,4.3,1.1z"
            />
            <path
                fill={color}
                d="M14,1.1c0.1,0,0.1,0.1,0.2,0.1c0,0,0.1,0,0.1,0c0,0-0.1-0.1-0.1-0.1C14.1,1,14.1,1.1,14,1.1z"
            />
            <path
                fill={color}
                d="M16.6,1.5C16.6,1.5,16.7,1.5,16.6,1.5c0.1,0,0.2,0,0.2,0C16.8,1.4,16.7,1.4,16.6,1.5
        		C16.6,1.4,16.6,1.4,16.6,1.5z"
            />
            <path
                fill={color}
                d="M19.4,1.9c0,0,0.1,0.1,0.1,0.1c0,0,0.1,0,0.1-0.1c0,0,0-0.1-0.1-0.2C19.5,1.9,19.4,1.9,19.4,1.9z"
            />
            <path
                fill={color}
                d="M13.3,1.6c0,0,0.1,0,0.1-0.1c0,0,0-0.1-0.1-0.1C13.3,1.5,13.3,1.5,13.3,1.6C13.3,1.6,13.3,1.6,13.3,1.6z"
            />
            <path
                fill={color}
                d="M12.7,1.5C12.7,1.4,12.6,1.4,12.7,1.5c-0.1,0-0.2,0-0.2,0C12.5,1.5,12.6,1.5,12.7,1.5
        		C12.7,1.5,12.7,1.5,12.7,1.5z"
            />
            <path
                fill={color}
                d="M14,2c0,0,0.1,0,0.1-0.1c0,0-0.1,0-0.1-0.1c0,0-0.1,0.1-0.1,0.1C13.9,2,14,2,14,2z"
            />
        </g>
    </svg>
);

LineSmaller.propTypes = propTypes;
LineSmaller.defaultProps = defaultProps;

export default LineSmaller;
